<template>
  <main class="container">
    <TheHeader />
    <div class="reg-loader">
      <vue-loaders
        name="ball-scale-multiple"
        color="#ef7d22"
        v-if="!nonCartRoutes.includes($route.name)"
      />
      <vue-loaders name="line-scale" color="#ef7d22" v-else />
    </div>
  </main>
</template>

<script>
import TheHeader from '@/components/flow/TheHeader.vue'

export default {
  name: 'LoadingLayout',
  components: {
    TheHeader,
  },
  props: {
    nonCartRoutes: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
.container {
  .reg-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50vh;
  }
}
</style>
